import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { UnitOption } from '../lab-test-results';
import { UnitStorage } from '../user/unit-storage';

@Component({
    selector: 'unit-selector',
    template: require('./unit-selector.component.html'),
    styles: [require('./unit-selector.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitSelectorComponent {
    public readonly unitOptions: UnitOption[];
    public selectedUnitOption: Observable<UnitOption>;

    constructor(private readonly unitStorage: UnitStorage) {
        this.unitOptions = unitStorage.unitOptions;
        this.selectedUnitOption = unitStorage.currentUnit;
    }

    public onUnitChanged(option: UnitOption) {
        this.unitStorage.setUnit(option);
    }
}
